// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3Y_Qd","loaderOuter":"PageOverlayLoader_loaderOuter__2sDdF"};